import forge from 'node-forge';

/**
 * 完全复现 Node.js crypto 模块的 RSA 加密功能
 * 使用 PKCS#1 v1.5 填充，与您的 Node.js 代码完全兼容
 */
export function encryptRSAWithPKCS1(
  modulusBase64: string,
  exponent: number,
  plainText: string
): string {
  try {
    // 将 base64 modulus 转换为 Buffer
    const modulusBuffer = forge.util.decode64(modulusBase64);
    
    // 将 Buffer 转换为 BigInteger
    const modulus = new forge.jsbn.BigInteger(forge.util.bytesToHex(modulusBuffer), 16);
    const exp = new forge.jsbn.BigInteger(exponent.toString());
    
    // 创建 RSA 公钥
    const publicKey = forge.pki.rsa.setPublicKey(modulus, exp);
    
    // 使用 PKCS#1 v1.5 填充进行加密
    const encrypted = publicKey.encrypt(plainText, 'RSAES-PKCS1-V1_5');
    
    // 转换为 base64
    return forge.util.encode64(encrypted);
  } catch (error) {
    console.error('RSA PKCS#1 encryption failed:', error);
    throw error;
  }
}
/**
 * 通用的 RSA 加密函数，兼容您现有的调用方式
 */
export function encryptRSAWithPub(
  modulus: string,
  exponent: number,
  data: string
): string {
  // 如果 modulus 是十六进制，先转换为 base64
  let modulusBase64: string;
  if (modulus.match(/^[0-9a-fA-F]+$/)) {
    // 十六进制格式
    const modulusBuffer = forge.util.hexToBytes(modulus);
    modulusBase64 = forge.util.encode64(modulusBuffer);
  } else {
    // 假设已经是 base64 格式
    modulusBase64 = modulus;
  }
  
  return encryptRSAWithPKCS1(modulusBase64, exponent, data);
}